import {Component} from '@angular/core';
import { GoogleAuthenticationService } from 'src/app/core/services/login/google-authentication.service';
import { WindowService } from 'src/app/core/services/window/window.service';

import { ChangeBpComponent } from './change-bp/change-bp.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthorizationService } from 'src/app/core/services/authorization/authorization.service';
import { CrewInfoStore } from 'src/app/core/services/crew-info/crew-info.store';
import { ChangePasswordComponent } from 'src/app/pages/external/external-home/change-password/change-password.component';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: false
})
export class NavbarComponent {

  constructor(
    private googleAuthenticationService: GoogleAuthenticationService,
    private authorizationService: AuthorizationService,
    private windowService: WindowService,
    private crewInfoStore: CrewInfoStore,
    public dialog: MatDialog) {
  }

  get photo(): string {
    return this.googleAuthenticationService.getGoogleUser()?.photo || '';
  }

  get name(): string {
    return this.crewInfoStore.crewInfo()?.firstName || '';
  }

  get isAdmin(): boolean {
    return this.authorizationService.isAdmin();
  }

  get isExternal(): boolean {
    return this.authorizationService.isExternal();
  }

  openDialogChangeBp(): void {
    this.dialog.open(ChangeBpComponent, { width: '600px' });
  }

  openDialogEditExternalCrew(): void {
    const crewInfo = this.crewInfoStore.crewInfo();

    this.dialog.open(ChangePasswordComponent, { 
      width: '775px', 
      autoFocus: false, 
      data: {
        crew: crewInfo,
        mode: 'details'
      }
    });
  }

  logout() {
    this.windowService.toOrigin();
    sessionStorage.clear();
  }

}
